import validate from "/opt/build/repo/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.6_@types+node@20.19.32_cac@6.7.14_db0@0.3.4_eslint@8.57_f74128c39824ad93d1c439882146bd58/node_modules/nuxt/dist/pages/runtime/validate.js";
import menu_45redirects_45global from "/opt/build/repo/middleware/menu-redirects.global.ts";
import netlify_45redirects_45global from "/opt/build/repo/middleware/netlify-redirects.global.ts";
import remove_45trailing_45slash_45global from "/opt/build/repo/middleware/remove-trailing-slash.global.ts";
import manifest_45route_45rule from "/opt/build/repo/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.6_@types+node@20.19.32_cac@6.7.14_db0@0.3.4_eslint@8.57_f74128c39824ad93d1c439882146bd58/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  menu_45redirects_45global,
  netlify_45redirects_45global,
  remove_45trailing_45slash_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}